module.exports = __webpack_public_path__ + "img/Frente-18-02 open.23e65f40.jpg";